<template>
  <form @submit.prevent="$emit('next')" class="thanks-page mt-9 mt-lg-0">
    <span>Opções da página</span>

    <bp-select
      class="my-5"
      id="select-option"
      :options="[
        { id: 'default', name: 'Gerar pela Blitzpay' },
        { id: 'external', name: 'Adicionar página externa' }
      ]"
      label="Escolha uma opção"
      placeholder="Escolha uma opção"
      v-model="type"
    />

    <div v-if="type === 'external'">
      <bp-input
        v-model="form.url_redirect"
        id="url_redirect"
        label="Compras aprovadas"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect"
        description="Esta página é exibida se a compra for feita com cartão de crédito e já estiver aprovada."
      />

      <bp-input
        class="mt-5"
        v-model="form.url_redirect_waiting"
        id="url_redirect_waiting"
        label="Compras por boleto"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect_waiting"
        description="Esta página é exibida se a compra for feita por boleto bancário e
        estiver aguardando aprovação. Deve ser usada com o widget de boleto."
      />

      <bp-input
        class="mt-5"
        v-model="form.url_redirect_credit_analysis"
        id="url_redirect_credit_analysis"
        label="Compras por pix"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect_credit_analysis"
        description="Esta página é exibida se a compra for feita por Pix e estiver aguardando
        aprovação."
      />

      <b-checkbox
        v-if="form.url_redirect_credit_analysis"
        v-model="form.has_redirect_pix"
        class="mt-5"
      >
        Página customizada de pagamento Pix
      </b-checkbox>
      <span
        class="fs-14 text-secondary"
        v-if="form.url_redirect_credit_analysis"
      >
        Marcar se deseja utilizar o widget de pagamento Pix. Caso contrário, o
        usuário será redirecionado para a página de obrigado após a aprovação do
        pagamento.
      </span>

      <div class="d-flex align-items-center mt-5">
        <bp-input
          class="flex-fill"
          id="billetScript"
          label="Script para widget de boleto"
          :value="billetScript"
          disabled
          link
        >
          <template #trailing-button>
            <bp-button
              icon="fa-regular fa-copy"
              type="button"
              size="md"
              variant="glyph"
              id="copy-billet"
              @click="copyBilletScript"
            />
          </template>
        </bp-input>
      </div>
      <div class="d-flex align-items-center">
        <bp-input
          class="flex-fill"
          id="upsellScript"
          label="Script para widget de upsell"
          :value="upsellScript"
          disabled
          link
        >
          <template #trailing-button>
            <bp-button
              icon="fa-regular fa-copy"
              type="button"
              size="md"
              variant="glyph"
              id="copy-upsell"
              @click="copyUpsellScript"
            />
          </template>
        </bp-input>
      </div>
      <div class="d-flex align-items-center">
        <bp-input
          class="flex-fill"
          id="pixScript"
          label="Script para widget de pix"
          :value="pixScript"
          disabled
          link
        >
          <template #trailing-button>
            <bp-button
              icon="fa-regular fa-copy"
              type="button"
              size="md"
              variant="glyph"
              id="copy-pix"
              @click="copyPixScript"
            />
          </template>
        </bp-input>
      </div>
      <div class="fs-14 text-secondary pt-5">
        Os códigos acima devem ser colocados dentro da tag body no código da sua
        página.
        <a
          target="_blank"
          href="https://ajuda.blitzpay.com.br/article/como-adicionar-um-widget-de-boleto-ou-upsell"
          class="text-primary font-weight-bold text-decoration-none"
        >
          Veja como adicionar um widget à sua página de checkout.
          <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
        </a>
      </div>
    </div>

    <!-- <hr class="mt-9 mb-9" />

    <div class="d-flex flex-column">
      <span class="font-weight-bold">Idioma</span>
      <span class="text-secondary "
        >Escolha em qual idioma devemos exibir a página de pagamento e enviar
        e-mails aos seus compradores.</span
      >

      <form-group
        type="radio"
        v-model="form.language"
        id="language"
        label=""
        :options="languageOptions"
        :errors="errors.language"
        :customClass="'col-12'"
      />
    </div> -->

    <div
      class="d-flex flex-column-reverse gap-5 flex-md-row justify-content-between mt-6"
    >
      <bp-button
        label="Voltar"
        color="neutral"
        icon="icon-angle-left"
        variant="filled-1"
        @click="$emit('cancel')"
      />

      <bp-button
        color="primary"
        :loading="loading"
        label="Salvar"
        type="submit"
        @click="$emit('next')"
      />
    </div>
  </form>
</template>

<script>
import copy from "copy-text-to-clipboard";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      externalPages:
        this.form.url_redirect !== "" ||
        this.form.url_redirect_waiting !== "" ||
        this.form.url_redirect_credit_analysis !== "",
      type: ""
    };
  },
  watch: {
    type(val) {
      if (val === "default") {
        this.form.url_redirect = "";
        this.form.url_redirect_waiting = "";
        this.form.url_redirect_credit_analysis = "";
      }
    }
  },
  computed: {
    billetScript() {
      return '<iframe id="blitzpay-billet-iframe"></iframe><script src="https://pay.blitzpay.com.br/static/js/billet-client.js"><\/script>';
    },
    upsellScript() {
      return '<iframe id="blitzpay-upsell-iframe"></iframe><script src="https://pay.blitzpay.com.br/static/js/upsell-client.js"><\/script>';
    },
    pixScript() {
      return '<iframe id="blitzpay-pix-iframe"></iframe><script src="https://pay.blitzpay.com.br/static/js/pix-client.js"><\/script>';
    }
  },
  methods: {
    copyBilletScript() {
      copy(this.billetScript);
      this.$message.success("Script copiado!");
    },
    copyUpsellScript() {
      copy(this.upsellScript);
      this.$message.success("Script copiado!");
    },
    copyPixScript() {
      copy(this.pixScript);
      this.$message.success("Script copiado!");
    }
  },
  mounted() {
    this.type = this.externalPages ? "external" : "default";
  }
};
</script>

<style lang="scss" scoped>
.thanks-page {
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
